import React from "react";
import { Check } from "lucide-react";
import { GiftCardVisual } from "./GiftCardVisual";

// Galleria "Scegli la grafica": miniature a forma di card dei temi (colori o immagine caricata dall'admin)
export function GiftThemePicker({ themes = [], value, onChange, appName, testidPrefix = "giftcard-theme" }) {
  if (!themes.length) return null;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testidPrefix}-picker`}>
      {themes.map((t) => {
        const sel = value === t.id;
        return (
          <button key={t.id} type="button" onClick={() => onChange(t.id)} aria-pressed={sel} data-testid={`${testidPrefix}-${t.id}`}
            className={`rounded-2xl p-1.5 text-left bg-white ring-2 transition ${sel ? "ring-zinc-900 shadow-md" : "ring-zinc-200 hover:ring-zinc-400"}`}>
            <div className="relative">
              <GiftCardVisual theme={t} thumb testid={`${testidPrefix}-thumb-${t.id}`} />
              {sel && <span className="absolute top-1.5 right-1.5 h-5 w-5 rounded-full bg-white text-zinc-900 flex items-center justify-center shadow" data-testid={`${testidPrefix}-selected`}><Check className="h-3 w-3" /></span>}
            </div>
            <div className={`text-[11px] font-semibold text-center mt-1 truncate ${sel ? "text-zinc-900" : "text-zinc-600"}`}>{t.label}</div>
          </button>
        );
      })}
    </div>
  );
}
